
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

export default {
components: {
Flexbox,
FlexboxItem,
Previewer,
InlineLoading
},
model: {
prop: 'images',
event: 'change'
},
props: {
images: {
type: Array,
default: () => []
},
readonly: {
type: Boolean,
default: false
},
max: {
type: Number,
default: 9
},
beforeUpload: Function,
withCredentials: {
type: Boolean,
default: false
},
data: {
type: Object,
default: () => {
return {}
}
},
span: {
type: Number,
default: 4
},
accept: {
type: String,
default: 'image/*'
},
capture: {
type: String,
default: ''
},
preview: {
type: Boolean,
default: true
},
compress: Object,
maxSize: Number
},
data () {
return {
loading: false,
isUpload: false
}
},
computed: {
showCapture () {
return this.capture || undefined
}
},
watch: {
loading: function (newValue) {
if (!newValue) {
this.$refs['file'].value = ''
}
}
},
methods: {
onChange (event) {
let num = event.target.files.length
if (num === 1) {
const file = event.target.files[0]
this.uploadFile(file)
} else {
const fileArr = event.target.files
for (let index = 0; index < fileArr.length; index++) {
this.uploadFile(fileArr[index])
}
}
},
uploadFile (file) {
if (this.images.length > this.max - 1) {
return false
} else {
let size = (this.maxSize / 1024 / 1024).toFixed(1)
if (file.size > this.maxSize) {
this.$vux.toast.text('上传图片大小不得超过' + size + 'M，请重新上传', 'middle')
} else {

if (this.beforeUpload && typeof this.beforeUpload === 'function') {
const before = this.beforeUpload(file)
if (before && before.then) {
before.then(processedFile => {
const fileType = Object.prototype.toString.call(processedFile)
if (fileType === '[object File]' || fileType === '[object Blob]') {
this.post(processedFile)
} else {
this.post(file)
}
})
} else if (before !== false) {
this.post(file)
}
} else {
this.post(file)
}
}
}
},
post (file) {
this.loading = true
let reader = new FileReader()
let data = []
reader.readAsDataURL(file)
reader.onloadend = () => {
data.push(reader.result)
this.onSuccess(file, data)
}
this.loading = false
},
onProgress (e) {
this.loading = true
},
onPreview (index) {
if (this.preview) {
this.$refs.previewer.show(index)
}
},
onSuccess (file, data) {
this.$emit('success', file, data)
},
onError (file) {
this.$emit('error', file)
},
onRemove (index, e) {
e.stopPropagation()
this.$emit('remove', index)
}
}
}



// WEBPACK FOOTER //
// ./src/components/upload.vue